import gsap from 'gsap'

// Enhanced floating animation with randomization and rotation
export const floatingAnimation = (ref, offset = 0) => {
  // Random values for more organic movement
  const randomY = 0.2 + Math.random() * 0.3 // More controlled random height
  const randomDuration = 2.5 + Math.random() * 1.5

  // Floating movement
  gsap.to(ref.current.position, {
    y: `+=${randomY}`,
    duration: randomDuration,
    yoyo: true,
    repeat: -1,
    ease: "power1.inOut",
    delay: offset
  })

  // Add complex rotation
  gsap.to(ref.current.rotation, {
    y: Math.PI * 2,
    x: Math.PI * 0.05, // Slight tilt
    duration: 15 + Math.random() * 10,
    repeat: -1,
    ease: "none",
    delay: offset
  })

  // Subtle scale pulsing
  gsap.to(ref.current.scale, {
    x: 1.05,
    y: 1.05,
    z: 1.05,
    duration: 2 + Math.random(),
    yoyo: true,
    repeat: -1,
    ease: "power1.inOut",
    delay: offset
  })
}

// Enhanced hover effects with glow
export const orbAnimation = {
  hover: {
    scale: 1.2,
    duration: 0.4,
    ease: "power2.out",
    glow: {
      intensity: 2,
      duration: 0.3,
      ease: "power2.out"
    }
  },
  reset: {
    scale: 1,
    duration: 0.3,
    ease: "power2.inOut",
    glow: {
      intensity: 1,
      duration: 0.4,
      ease: "power2.inOut"
    }
  }
}

// Enhanced connection line animation
export const lineAnimation = {
  pulse: {
    opacity: [0.15, 0.4], // Subtler opacity range
    duration: 3,
    yoyo: true,
    repeat: -1,
    ease: "power1.inOut"
  },
  highlight: {
    opacity: 0.6,
    duration: 0.3,
    ease: "power2.out",
    width: 2 // Line thickness increase
  },
  reset: {
    opacity: 0.2,
    duration: 0.5,
    ease: "power2.out",
    width: 1
  }
}

// Enhanced modal transition
export const modalAnimation = {
  open: {
    opacity: 0,
    scale: 0.9,
    duration: 0.5,
    ease: "power3.out"
  },
  visible: {
    opacity: 1,
    scale: 1,
    duration: 0.5,
    stagger: {
      amount: 0.3,
      from: "start"
    }
  },
  content: {
    y: [20, 0],
    opacity: [0, 1],
    duration: 0.4,
    stagger: 0.1,
    ease: "power2.out"
  }
}

// Enhanced shimmer effect for connection lines
export const createShimmerEffect = (material) => {
  // Base opacity animation
  gsap.to(material, {
    opacity: 0.4,
    duration: 2,
    yoyo: true,
    repeat: -1,
    ease: "power1.inOut"
  })

  // Additional sparkle effect
  const sparkleTimeline = gsap.timeline({ repeat: -1 })
  sparkleTimeline.to(material, {
    opacity: 0.8,
    duration: 0.1,
    ease: "none"
  })
  sparkleTimeline.to(material, {
    opacity: 0.2,
    duration: 0.1,
    ease: "none"
  })
  sparkleTimeline.to(material, {
    opacity: 0.4,
    duration: 1.8,
    ease: "power1.inOut"
  })

  return sparkleTimeline
}

// New: Glow pulse animation
export const glowPulseAnimation = (intensity = 1) => ({
  value: [intensity * 0.7, intensity],
  duration: 2,
  yoyo: true,
  repeat: -1,
  ease: "power1.inOut"
})

// New: Size variation animation
export const sizeVariationAnimation = (ref, baseSize) => {
  const timeline = gsap.timeline({ repeat: -1 })
  const variationAmount = baseSize * 0.1

  timeline.to(ref.current.scale, {
    x: 1 + variationAmount,
    y: 1 + variationAmount,
    z: 1 + variationAmount,
    duration: 2 + Math.random(),
    ease: "power1.inOut"
  })
  timeline.to(ref.current.scale, {
    x: 1,
    y: 1,
    z: 1,
    duration: 2 + Math.random(),
    ease: "power1.inOut"
  })

  return timeline
} 